import { OpenFeature } from '@openfeature/web-sdk';

import type { AccountState } from '../../reducers/account.reducer';
import {
  type CurrentAppContext,
  buildFeatureFlagEvaluationContext,
} from './core/featureFlagContext';
import {
  type InitializeDatadogFeatureFlagsOptions,
  initializeDatadogFeatureFlags as initializeDatadogProvider,
} from './providers/datadogProvider';
import { initializeHarnessFeatureFlags as initializeHarnessProvider } from './providers/harnessProvider';

export function initializeFeatureFlags(options: InitializeDatadogFeatureFlagsOptions = {}): void {
  initializeDatadogProvider(options);
  initializeHarnessProvider();
}

export function setFeatureFlagContext(
  account: AccountState,
  currentApp: CurrentAppContext,
  isFlipdishStaff: boolean
): void {
  const evaluationContext = buildFeatureFlagEvaluationContext(account, currentApp, isFlipdishStaff);

  void OpenFeature.setContext(evaluationContext).catch((error: unknown) => {
    console.error('[FeatureFlags] Failed to update OpenFeature context.', error);
  });
}
